import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

export type CPCReqHistoryProgramFeesLocNames =
	| 'CPCReqHistoryProgramFeesPageTitle'
	| 'CPCReqHistoryProgramFeesPageDescription'
	| 'CPCReqHistoryProgramFeesGroupNameLabel'
	| 'CPCReqHistoryProgramFeesNameLabel'
	| 'CPCReqHistoryProgramFeesPointsLabel'
	| 'CPCReqHistoryProgramFeesActiveDateLabel'
	| 'CPCReqHistoryProgramFeesExpireDateLabel'
	| 'CPCReqHistoryProgramFeesButtonGoBack'
	| 'CPCReqHistoryProgramFeesButtonInfo';

export const creqProgramFeesLocs: LocDefs<CPCReqHistoryProgramFeesLocNames> = {
	// Page level
	CPCReqHistoryProgramFeesPageTitle: {
		defaultValue: 'Program Fees',
		description: 'Page title for: Program Fees.',
		displayPath: 'History|Program Fees|Page Title',
		portal: 'CP',
		displayType: 'Title',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
	},
	CPCReqHistoryProgramFeesPageDescription: {
		defaultValue: '',
		description: 'Page description for: Program Fees.',
		displayPath: 'History|Program Fees|Page Description',
		portal: 'CP',
		displayType: 'Content',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: true,
		shared: false,
	},

	// Buttons
	CPCReqHistoryProgramFeesButtonGoBack: {
		defaultValue: 'Go Back',
		description: 'Button label for: Go Back.',
		displayPath: 'History|Program Fees|Go Back',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
	},
	CPCReqHistoryProgramFeesButtonInfo: {
		defaultValue: 'Info',
		description: 'Button label for: Info.',
		displayPath: 'History|Program Fees|Info',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
	},

	// Original Field Labels
	CPCReqHistoryProgramFeesGroupNameLabel: {
		defaultValue: 'Group',
		description: 'Field label for: Group.',
		displayPath: 'History|Program Fees|Group',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
	},
	CPCReqHistoryProgramFeesPointsLabel: {
		defaultValue: 'Points',
		description: 'Field label for: Points.',
		displayPath: 'History|Program Fees|Points',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		htmlAllowed: false,
		shared: false,
	},
	CPCReqHistoryProgramFeesNameLabel: {
		defaultValue: 'Name',
		description: 'Field label for: Name.',
		displayPath: 'History|Program Fees|Name',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
	},
	CPCReqHistoryProgramFeesActiveDateLabel: {
		defaultValue: 'Active Date',
		description: 'Field label for: Active Date.',
		displayPath: 'History|Program Fees|Active Date',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
	},
	CPCReqHistoryProgramFeesExpireDateLabel: {
		defaultValue: 'Expire Date',
		description: 'Field label for: Expire Date.',
		displayPath: 'History|Program Fees|Expire Date',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
	},
};

export const cpCreqProgramFeesLocKeys =
	MapLocKeys<CPCReqHistoryProgramFeesLocNames>(creqProgramFeesLocs);
export type CPCreqHistoryProgramFeesLocKeys = typeof cpCreqProgramFeesLocKeys;
